var map = {
	"./img_1.jpg": 8937,
	"./img_2.jpg": 52846,
	"./img_3.jpg": 39541,
	"./img_4.jpg": 26191,
	"./img_5.jpg": 13768,
	"./img_6.jpg": 95832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8938;